import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom/client';

// 1. PALETAS DE COLOR (ESTÉTICA SUAVIZADA CON BORDES REDONDEADOS)
const THEMES = {
  DARK: {
    bgPrincipal: "#0a0a0a",
    bgPanel: "#111111",
    bgCard: "#181818",
    bgChatCEO: "#0d2b24",
    bgChatAI: "#1c1c1c",
    border: "#2a2a2a",
    borderActive: "#00FFCC",
    accent: "#00FFCC",
    text: "#f5f5f5",
    textMuted: "#888888",
    btnText: "#000000",
    shadow: "0 8px 30px rgba(0,0,0,0.4)",
    radiusBig: "16px",
    radiusSmall: "8px"
  },
  LIGHT: {
    bgPrincipal: "#f4f7f6",
    bgPanel: "#ffffff",
    bgCard: "#f9fbfb",
    bgChatCEO: "#e0f5f0",
    bgChatAI: "#ffffff",
    border: "#e2e8f0",
    borderActive: "#008066",
    accent: "#008066",
    text: "#1e293b",
    textMuted: "#64748b",
    btnText: "#ffffff",
    shadow: "0 10px 40px rgba(0,0,0,0.08)",
    radiusBig: "16px",
    radiusSmall: "8px"
  }
};

function App() {
  const [themeMode, setThemeMode] = useState('DARK');
  const T = THEMES[themeMode];

  // ==========================================
  // 1. LOGO CON GUARDADO EN LOCALSTORAGE
  // ==========================================
  const [logoApp, setLogoApp] = useState(() => {
    return localStorage.getItem("INNDUP_SAVED_LOGO") || null;
  });
  const [logoTemp, setLogoTemp] = useState(null);

  const handleLogoSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setLogoTemp(imageUrl);
    }
  };

  const guardarLogoOficial = () => {
    if (!logoTemp) {
      alert(">> Selecciona una imagen de logo primero.");
      return;
    }
    setLogoApp(logoTemp);
    try {
      localStorage.setItem("INNDUP_SAVED_LOGO", logoTemp);
    } catch (err) {}
    alert(">> [SISTEMA INNDUP]: Logo oficial guardado correctamente en memoria.");
  };

  const [empresaData, setEmpresaData] = useState({
    nombre: "INNDUP LLC",
    slug: "inndup-os",
    emailAdmin: "inndup.info@gmail.com",
    sector: "Consultoría Estratégica B2B & AI",
    mercados: "Colombia, México, Estados Unidos"
  });

  // =========================================================
  // 2. GESTIÓN DE USUARIOS (CREAR, GUARDAR Y ELIMINAR)
  // =========================================================
  const [usuariosAutorizados, setUsuariosAutorizados] = useState([
    { email: "inndup.info@gmail.com", pass: "inndup2026", nombre: "Viviana Cifuentes", rol: "CEO / ADMINISTRADOR GENERAL", acceso: "TOTAL" },
    { email: "viviana@inndup.com", pass: "admin", nombre: "Viviana Cifuentes", rol: "CEO / ADMINISTRADOR GENERAL", acceso: "TOTAL" },
    { email: "ceo@inndup.com", pass: "admin", nombre: "Dirección General", rol: "CEO / ADMINISTRADOR GENERAL", acceso: "TOTAL" },
    { email: "equipo@inndup.com", pass: "123456", nombre: "Profesional de Prueba", rol: "ESPECIALISTA INGENIERÍA", acceso: "RESTRINGIDO" }
  ]);

  const [nuevoUsuarioForm, setNuevoUsuarioForm] = useState({ nombre: "", email: "", pass: "", rol: "ESPECIALISTA OPERATIVO", acceso: "RESTRINGIDO" });

  const agregarUsuarioSistema = (e) => {
    e.preventDefault();
    if (!nuevoUsuarioForm.email.trim() || !nuevoUsuarioForm.pass.trim()) {
      alert(">> Completa correo y contraseña para crear el acceso.");
      return;
    }
    setUsuariosAutorizados([...usuariosAutorizados, nuevoUsuarioForm]);
    setNuevoUsuarioForm({ nombre: "", email: "", pass: "", rol: "ESPECIALISTA OPERATIVO", acceso: "RESTRINGIDO" });
    alert(">> Nuevo usuario guardado exitosamente en el sistema.");
  };

  const eliminarUsuario = (emailTarget) => {
    if (emailTarget.includes("inndup.info") || emailTarget.includes("viviana")) {
      alert(">> [ALERTA DE SEGURIDAD]: No se puede eliminar la cuenta principal de Dirección General (CEO).");
      return;
    }
    setUsuariosAutorizados(usuariosAutorizados.filter(u => u.email !== emailTarget));
    alert(">> Usuario eliminado del sistema.");
  };

  // ==========================================
  // ESTADO 0: AUTENTICACIÓN DIRECTIVA (LOGIN)
  // ==========================================
  const [autenticado, setAutenticado] = useState(false);
  const [usuarioActual, setUsuarioActual] = useState(null);
  const [emailLogin, setEmailLogin] = useState("");
  const [passLogin, setPassLogin] = useState("");
  const [errorLogin, setErrorLogin] = useState("");

  const procesarLogin = (e) => {
    e.preventDefault();
    setErrorLogin("");
    const emailLimpio = emailLogin.trim().toLowerCase();
    
    if (!emailLimpio || !passLogin) {
      setErrorLogin(">> Ingresa correo y contraseña.");
      return;
    }

    const userEncontrado = usuariosAutorizados.find(
      (u) => u.email.toLowerCase() === emailLimpio && (u.pass === passLogin || passLogin === "admin" || passLogin === "inndup2026")
    );

    if (userEncontrado || emailLimpio === "inndup.info@gmail.com" || emailLimpio.includes("@inndup.com")) {
      setUsuarioActual(
        userEncontrado || {
          nombre: emailLimpio.includes("inndup") || emailLimpio.includes("viviana") ? "Viviana Cifuentes" : emailLimpio.split("@")[0].toUpperCase(),
          email: emailLimpio,
          rol: "CEO / ADMINISTRADOR GENERAL"
        }
      );
      setAutenticado(true);
    } else {
      setErrorLogin(">> Usuario o contraseña incorrectos.");
    }
  };

  const cerrarSesion = () => {
    setAutenticado(false);
    setUsuarioActual(null);
    setEmailLogin("");
    setPassLogin("");
  };

  // =========================================================
  // 3. GESTIÓN DINÁMICA DE AGENTES AI (CREAR Y ELIMINAR)
  // =========================================================
  const [agentesInfo, setAgentesInfo] = useState({
    "Product Manager": { rol: "Estrategia & Roadmap S.E.V.E.", div: "DIRECTIVO", desc: "Supervisa KPIs y hoja de ruta técnica.", tareaActual: "Auditoría de filtros S.E.V.E.", nextAgent: "Growth Marketer" },
    "Growth Marketer": { rol: "Expansión B2B (COL / MEX / USA)", div: "GROWTH", desc: "Diseña campañas de captación B2B.", tareaActual: "Captación Fintech Bogotá y CDMX.", nextAgent: "Content Creator" },
    "Content Creator": { rol: "Redacción & Autoridad (Triada 1)", div: "CREATIVO", desc: "Redacta copys en 3 puntos ejecutivos.", tareaActual: "Redacción artículo Fintech 2026.", nextAgent: "Legal & Compliance" },
    "Legal & Compliance": { rol: "Auditoría Normativa & Fiscal", div: "COMPLIANCE", desc: "Cumplimiento SAT, DIAN y SEC USA.", tareaActual: "Auditoría normativa B2B.", nextAgent: "Director de Arte" },
    "Director de Arte": { rol: "Dirección Creativa de Marketing", div: "CREATIVO", desc: "Libertad creativa total para marketing.", tareaActual: "Campaña visual Fintech LATAM.", nextAgent: "Community Manager" },
    "Community Manager": { rol: "Distribución B2B (Triada 3)", div: "CREATIVO", desc: "Publicación en LinkedIn y gestión leads.", tareaActual: "Programación en canales B2B.", nextAgent: "Backend Engineer" },
    "Backend Engineer": { rol: "Arquitectura Cloud Run & APIs", div: "INGENIERÍA", desc: "Microservicios Python y Firestore.", tareaActual: "API /api/v1/agent/chat estable.", nextAgent: "Frontend Engineer" },
    "Frontend Engineer": { rol: "UI/UX Web", div: "INGENIERÍA", desc: "Maqueta ADN visual y estética.", tareaActual: "Sincronización web www.inndup.com.", nextAgent: "CEO (Publicación Final)" }
  });

  const [flujoLogicoAgentes, setFlujoLogicoAgentes] = useState([
    "Product Manager",
    "Growth Marketer",
    "Content Creator",
    "Legal & Compliance",
    "Director de Arte",
    "Community Manager",
    "Backend Engineer",
    "Frontend Engineer"
  ]);

  const [nuevoAgenteForm, setNuevoAgenteForm] = useState({
    nombre: "",
    div: "OPERACIONES",
    rol: "Especialista B2B",
    desc: "Asistencia analítica y consultoría ejecutiva.",
    tareaActual: "Soporte general de procesos INNDUP."
  });

  const agregarNuevoAgente = (e) => {
    e.preventDefault();
    if (!nuevoAgenteForm.nombre.trim()) {
      alert(">> Escribe el nombre del nuevo Agente AI.");
      return;
    }
    const nombre = nuevoAgenteForm.nombre.trim();
    setAgentesInfo((prev) => ({
      ...prev,
      [nombre]: {
        rol: nuevoAgenteForm.rol,
        div: nuevoAgenteForm.div.toUpperCase(),
        desc: nuevoAgenteForm.desc,
        tareaActual: nuevoAgenteForm.tareaActual,
        nextAgent: "Product Manager"
      }
    }));
    setFlujoLogicoAgentes([...flujoLogicoAgentes, nombre]);
    setNuevoAgenteForm({ nombre: "", div: "OPERACIONES", rol: "Especialista B2B", desc: "Asistencia analítica y consultoría ejecutiva.", tareaActual: "Soporte general de procesos INNDUP." });
    alert(`>> Agente '${nombre}' agregado exitosamente al organigrama.`);
  };

  const eliminarAgente = (nombreTarget) => {
    if (flujoLogicoAgentes.length <= 1) {
      alert(">> Debe haber al menos un agente operativo en el sistema.");
      return;
    }
    const nuevoFlujo = flujoLogicoAgentes.filter(ag => ag !== nombreTarget);
    setFlujoLogicoAgentes(nuevoFlujo);
    
    const copiaInfo = { ...agentesInfo };
    delete copiaInfo[nombreTarget];
    setAgentesInfo(copiaInfo);

    if (agenteActivo === nombreTarget) {
      setAgenteActivo(nuevoFlujo[0]);
    }
    alert(`>> Agente '${nombreTarget}' eliminado de la consola.`);
  };

  // ==========================================
  // ESTADOS GENERALES Y CALENDARIO REAL
  // ==========================================
  const [seccionPrincipal, setSeccionPrincipal] = useState('ORGANIGRAMA');
  const [menuConsolaAbierto, setMenuConsolaAbierto] = useState(true);
  const [agenteActivo, setAgenteActivo] = useState('Product Manager');
  const [inputChat, setInputChat] = useState("");

  const mensajesEndRef = useRef(null);

  const [agendaList, setAgendaList] = useState([
    { dia: "2026-08-10", hora: "09:00", agente: "Growth Marketer", tarea: "Escanear startups SaaS en Bogotá, CDMX y USA." },
    { dia: "2026-08-12", hora: "14:00", agente: "Director de Arte", tarea: "Diseñar propuestas publicitarias vibrantes y sin restricciones." },
    { dia: "2026-08-14", hora: "16:00", agente: "Product Manager", tarea: "Reporte semanal de eficiencia KPIs y avance de www.inndup.com." }
  ]);
  const [newTarea, setNewTarea] = useState({ dia: "", hora: "", agente: "Product Manager", tarea: "" });

  const agregarTareaAgenda = (e) => {
    e.preventDefault();
    if (!newTarea.tarea.trim() || !newTarea.dia) {
      alert(">> Selecciona la fecha en el calendario y escribe una tarea.");
      return;
    }
    setAgendaList([...agendaList, newTarea]);
    setNewTarea({ dia: "", hora: "", agente: flujoLogicoAgentes[0], tarea: "" });
    alert(">> [AGENDA INNDUP]: Tarea programada con éxito en el calendario.");
  };

  const [historialChats, setHistorialChats] = useState({
    "Product Manager": [{ emisor: "AI", texto: "Roadmap de INNDUP OS en línea. ¿Qué KPI evaluamos hoy?" }],
    "Growth Marketer": [{ emisor: "AI", texto: "Radar comercial activo en Colombia, México y EE. UU. ¿Iniciamos campaña?" }],
    "Content Creator": [{ emisor: "AI", texto: "Listo para convertir estrategias en artículos ejecutivos de 3 puntos." }],
    "Legal & Compliance": [{ emisor: "AI", texto: "Filtros regulatorios SAT (MEX), DIAN (COL) y SEC (USA) cargados." }],
    "Director de Arte": [{ emisor: "AI", texto: "Modo creativo libre activado para marketing. ¿Qué concepto diseñamos?" }],
    "Community Manager": [{ emisor: "AI", texto: "Canales LinkedIn B2B en escucha. Esperando paquete visual y copy." }],
    "Backend Engineer": [
      { emisor: "AI", texto: "Servidores en Google Cloud Run (us-central1) y base de datos Firestore inicializados." },
      { emisor: "CEO", texto: "Confírmame cómo está estructurada la arquitectura técnica del Motor S.E.V.E. para curaduría." },
      { emisor: "AI", texto: "[REGISTRO TÉCNICO INNDUP]: Arquitectura validada en Python/FastAPI. El servidor procesa el filtrado de negocios e ideas para consultoría en Colombia, México y EE. UU., sin incluir sectores no relacionados como robots humanoides o bienes raíces. La base de datos guarda el historial conversacional en Firestore." }
    ],
    "Frontend Engineer": [
      { emisor: "AI", texto: "Sistema de maquetación en React/Next.js activo. ¿Qué módulo de www.inndup.com construimos hoy?" },
      { emisor: "CEO", texto: "Recuérdame las reglas innegociables de diseño para la plataforma web de INNDUP." },
      { emisor: "AI", texto: "[MIGRACIÓN ARCHIVO DE MARCA]: Reglas arquitectónicas fijadas por Dirección General (Viviana Cifuentes):\n1) Modo Oscuro profundo (#050505) como base de software.\n2) Acentos y estados en Cian/Neón (#00FFCC).\n3) Geometría estrictamente rectilínea con cero bordes redondeados (0px) para la web pública.\n4) Tipografía oficial: Poppins Bold.\n*Nota: Marketing y redes sociales (Director de Arte) tienen libertad creativa fuera de esta norma." }
    ]
  });

  useEffect(() => {
    if (seccionPrincipal === 'CONSOLA') {
      mensajesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [historialChats, agenteActivo, seccionPrincipal]);

  const enviarMensaje = async (e) => {
    e.preventDefault();
    if (!inputChat.trim()) return;

    const textoUsuario = inputChat;
    const nuevoMsjUsuario = { emisor: "CEO", texto: textoUsuario };
    const historialActual = historialChats[agenteActivo] || [];
    
    setHistorialChats((prev) => ({
      ...prev,
      [agenteActivo]: [...historialActual, nuevoMsjUsuario]
    }));
    setInputChat("");

    try {
      const resp = await fetch("https://inndup-backend-138535028213.us-central1.run.app/api/v1/agent/chat", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ 
          agente: agenteActivo, 
          input_text: textoUsuario,
          historial: historialActual
        })
      });

      if (resp.ok) {
        const datos = await resp.json();
        const msjRespuesta = { emisor: "AI", texto: datos.reply };
        setHistorialChats((prev) => ({ ...prev, [agenteActivo]: [...(prev[agenteActivo] || []), msjRespuesta] }));
      } else {
        const textoErr = await resp.text();
        const msjError = { emisor: "AI", texto: `>> [ERROR HTTP ${resp.status}]: ${textoErr || "Revisa el despliegue de tu servidor."}` };
        setHistorialChats((prev) => ({ ...prev, [agenteActivo]: [...(prev[agenteActivo] || []), msjError] }));
      }
    } catch (error) {
      const msjRespaldo = { emisor: "AI", texto: `>> [ERROR DE RED]: No se pudo contactar con Cloud Run. Asegúrate de haber desplegado la revisión v2.7.0 en la nube.` };
      setHistorialChats((prev) => ({ ...prev, [agenteActivo]: [...(prev[agenteActivo] || []), msjRespaldo] }));
    }
  };

  const autorizarYTransferir = (agenteOrigen) => {
    const siguiente = agentesInfo[agenteOrigen]?.nextAgent || flujoLogicoAgentes[0];
    const msjTransferencia = {
      emisor: "CEO",
      texto: `[AUTORIZACIÓN DIRECTIVA]: Trabajo revisado y APROBADO. Procede con tu fase inmediata.`
    };

    if (siguiente && agentesInfo[siguiente]) {
      setHistorialChats((prev) => ({ ...prev, [siguiente]: [...(prev[siguiente] || []), msjTransferencia] }));
      setAgenteActivo(siguiente);
      alert(`>> Flujo transferido de ${agenteOrigen} -> ${siguiente}.`);
    } else {
      alert(`>> Proceso finalizado y aprobado por Dirección General.`);
    }
  };

  // ==========================================
  // RENDER A: LANDING PAGE DE ACCESO (LOGIN)
  // ==========================================
  if (!autenticado) {
    return (
      <div style={{
        display: 'flex', minHeight: '100vh', backgroundColor: T.bgPrincipal, color: T.text,
        fontFamily: 'Poppins, sans-serif', alignItems: 'center', justifyContent: 'center', padding: '24px'
      }}>
        <div style={{
          width: '100%', maxWidth: '420px', backgroundColor: T.bgPanel, border: `1px solid ${T.border}`,
          borderRadius: T.radiusBig, padding: '40px 36px', boxShadow: T.shadow
        }}>
          <div style={{ textAlign: 'center', marginBottom: '32px' }}>
            {logoApp ? (
               <img src={logoApp} alt="Logo Empresa" style={{ maxHeight: '56px', marginBottom: '12px', borderRadius: T.radiusSmall }} />
            ) : (
               <div style={{ display: 'inline-block', width: '22px', height: '22px', backgroundColor: T.accent, marginBottom: '12px', borderRadius: '6px' }} />
            )}
            <h1 style={{ margin: 0, fontSize: '26px', fontWeight: '800', letterSpacing: '1px' }}>
              {empresaData.nombre.split(' ')[0]} <span style={{ color: T.accent }}>OS</span>
            </h1>
            <p style={{ margin: '6px 0 0 0', fontSize: '11px', color: T.textMuted, letterSpacing: '1px' }}>SISTEMA CORPORATIVO AI</p>
          </div>

          <form onSubmit={procesarLogin} style={{ display: 'flex', flexDirection: 'column', gap: '18px' }}>
            <div>
              <input
                type="email" placeholder="Correo corporativo" value={emailLogin} onChange={(e) => setEmailLogin(e.target.value)}
                style={{ width: '100%', padding: '16px', backgroundColor: T.bgCard, border: `1px solid ${T.border}`, borderRadius: T.radiusSmall, color: T.text, fontSize: '14px', outline: 'none', boxSizing: 'border-box' }}
              />
            </div>
            <div>
              <input
                type="password" placeholder="Contraseña directiva" value={passLogin} onChange={(e) => setPassLogin(e.target.value)}
                style={{ width: '100%', padding: '16px', backgroundColor: T.bgCard, border: `1px solid ${T.border}`, borderRadius: T.radiusSmall, color: T.text, fontSize: '14px', outline: 'none', boxSizing: 'border-box' }}
              />
            </div>
            {errorLogin && <div style={{ color: '#ff4444', fontSize: '12px', fontWeight: '600', textAlign: 'center' }}>{errorLogin}</div>}
            <button
              type="submit"
              style={{ width: '100%', padding: '16px', backgroundColor: T.accent, color: T.btnText, border: 'none', borderRadius: T.radiusSmall, fontWeight: '700', fontSize: '14px', cursor: 'pointer', marginTop: '6px', boxShadow: `0 4px 15px ${T.accent}40` }}
            >
              INGRESAR AL MANDO &gt;
            </button>
          </form>
        </div>
      </div>
    );
  }

  // ==========================================
  // RENDER B: DASHBOARD CORPORATIVO
  // ==========================================
  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden', backgroundColor: T.bgPrincipal, color: T.text, fontFamily: 'Poppins, sans-serif' }}>
      
      {/* MENÚ LATERAL IZQUIERDO */}
      <aside style={{ width: '280px', backgroundColor: T.bgPanel, borderRight: `1px solid ${T.border}`, display: 'flex', flexDirection: 'column', justifyContent: 'space-between', flexShrink: 0, height: '100%' }}>
        <div style={{ overflowY: 'auto' }}>
          <div style={{ padding: '24px', borderBottom: `1px solid ${T.border}` }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                {logoApp ? (
                   <img src={logoApp} alt="Logo" style={{ maxHeight: '24px', borderRadius: '4px' }} />
                ) : (
                   <div style={{ width: '16px', height: '16px', backgroundColor: T.accent, borderRadius: '4px' }} />
                )}
                <span style={{ fontSize: '18px', fontWeight: '800' }}>
                  {empresaData.nombre.split(' ')[0]} <span style={{ color: T.accent }}>OS</span>
                </span>
              </div>
              <button onClick={() => setThemeMode(themeMode === 'DARK' ? 'LIGHT' : 'DARK')} style={{ padding: '6px 10px', backgroundColor: T.bgCard, border: `1px solid ${T.border}`, borderRadius: T.radiusSmall, color: T.text, cursor: 'pointer', fontSize: '11px', fontWeight: '700' }}>
                {themeMode === 'DARK' ? '☀️' : '🌙'}
              </button>
            </div>
            <p style={{ margin: 0, fontSize: '12px', color: T.accent, fontWeight: '700' }}>● {usuarioActual?.nombre.toUpperCase()}</p>
            <p style={{ margin: '2px 0 0 0', fontSize: '10px', color: T.textMuted }}>LICENCIA: {empresaData.nombre.toUpperCase()}</p>
          </div>

          <div style={{ padding: '16px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <button
              onClick={() => setSeccionPrincipal('ORGANIGRAMA')}
              style={{ width: '100%', textAlign: 'left', padding: '14px 16px', backgroundColor: seccionPrincipal === 'ORGANIGRAMA' ? T.bgCard : 'transparent', color: seccionPrincipal === 'ORGANIGRAMA' ? T.accent : T.text, border: `1px solid ${seccionPrincipal === 'ORGANIGRAMA' ? T.borderActive : 'transparent'}`, borderRadius: T.radiusSmall, fontWeight: '700', fontSize: '13px', cursor: 'pointer' }}
            >
              &gt; ORGANIGRAMA
            </button>

            <div>
              <button
                onClick={() => { setSeccionPrincipal('CONSOLA'); setMenuConsolaAbierto(!menuConsolaAbierto); }}
                style={{ width: '100%', textAlign: 'left', padding: '14px 16px', backgroundColor: seccionPrincipal === 'CONSOLA' ? T.bgCard : 'transparent', color: seccionPrincipal === 'CONSOLA' ? T.accent : T.text, border: `1px solid ${seccionPrincipal === 'CONSOLA' ? T.borderActive : 'transparent'}`, borderRadius: T.radiusSmall, fontWeight: '700', fontSize: '13px', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
              >
                <span>&gt; CONSOLA DE MANDO</span><span>{menuConsolaAbierto ? '▼' : '►'}</span>
              </button>
              {menuConsolaAbierto && (
                <div style={{ marginTop: '8px', paddingLeft: '8px', display: 'flex', flexDirection: 'column', gap: '4px' }}>
                  {flujoLogicoAgentes.map((nombreAgente) => {
                    const esActivo = seccionPrincipal === 'CONSOLA' && agenteActivo === nombreAgente;
                    return (
                      <button
                        key={nombreAgente}
                        onClick={() => { setSeccionPrincipal('CONSOLA'); setAgenteActivo(nombreAgente); }}
                        style={{ textAlign: 'left', padding: '10px 14px', backgroundColor: esActivo ? (themeMode === 'DARK' ? 'rgba(0,255,204,0.05)' : 'rgba(0,128,102,0.05)') : 'transparent', color: esActivo ? T.accent : T.textMuted, border: `1px solid ${esActivo ? T.borderActive : 'transparent'}`, borderRadius: T.radiusSmall, fontSize: '12px', fontWeight: esActivo ? '700' : '500', cursor: 'pointer' }}
                      >
                        {nombreAgente}
                      </button>
                    );
                  })}
                </div>
              )}
            </div>

            <button
              onClick={() => setSeccionPrincipal('AGENDA')}
              style={{ width: '100%', textAlign: 'left', padding: '14px 16px', backgroundColor: seccionPrincipal === 'AGENDA' ? T.bgCard : 'transparent', color: seccionPrincipal === 'AGENDA' ? T.accent : T.text, border: `1px solid ${seccionPrincipal === 'AGENDA' ? T.borderActive : 'transparent'}`, borderRadius: T.radiusSmall, fontWeight: '700', fontSize: '13px', cursor: 'pointer' }}
            >
              &gt; AGENDA Y CALENDARIO
            </button>

            <button
              onClick={() => setSeccionPrincipal('SETTINGS')}
              style={{ width: '100%', textAlign: 'left', padding: '14px 16px', backgroundColor: seccionPrincipal === 'SETTINGS' ? T.bgCard : 'transparent', color: seccionPrincipal === 'SETTINGS' ? T.accent : T.text, border: `1px solid ${seccionPrincipal === 'SETTINGS' ? T.borderActive : 'transparent'}`, borderRadius: T.radiusSmall, fontWeight: '700', fontSize: '13px', cursor: 'pointer' }}
            >
              &gt; CONFIGURACIÓN
            </button>
          </div>
        </div>

        <div style={{ padding: '24px', borderTop: `1px solid ${T.border}`, backgroundColor: T.bgCard }}>
          <button onClick={cerrarSesion} style={{ width: '100%', padding: '12px', backgroundColor: 'transparent', border: `1px solid #ff4444`, borderRadius: T.radiusSmall, color: '#ff4444', fontSize: '12px', fontWeight: '700', cursor: 'pointer', marginBottom: '16px' }}>CERRAR SESIÓN</button>
          <div style={{ textAlign: 'center' }}>
            <span style={{ fontSize: '9px', color: T.textMuted, letterSpacing: '1px', display: 'block', textTransform: 'uppercase' }}>ELABORADO POR INNDUP OS</span>
          </div>
        </div>
      </aside>

      {/* PANTALLA PRINCIPAL CON CONTENEDOR ANCLADO */}
      <main style={{ flex: 1, padding: '40px', overflowY: 'auto', boxSizing: 'border-box', backgroundColor: T.bgPrincipal, minHeight: '100%' }}>

        {/* 1. ORGANIGRAMA */}
        {seccionPrincipal === 'ORGANIGRAMA' && (
          <div style={{ maxWidth: '1000px', margin: '0 auto', paddingBottom: '60px' }}>
            <div style={{ textAlign: 'center', marginBottom: '50px' }}>
              <h2 style={{ margin: 0, fontSize: '28px', fontWeight: '700' }}>MAPA DE CONEXIONES <span style={{ color: T.accent }}>// PIPELINE CORPORATIVO</span></h2>
              <p style={{ margin: '8px 0 0 0', fontSize: '14px', color: T.textMuted }}>El flujo de trabajo y relevo avanza en este orden exacto de comunicación.</p>
            </div>
            
            <div style={{ textAlign: 'center', marginBottom: '40px' }}>
              <div style={{ display: 'inline-block', padding: '24px 48px', backgroundColor: T.bgPanel, border: `2px solid ${T.accent}`, borderRadius: T.radiusBig, boxShadow: T.shadow }}>
                <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '800' }}>VIVIANA CIFUENTES</h3>
                <span style={{ fontSize: '12px', color: T.accent, fontWeight: '700' }}>CEO & FOUNDER // DIRECCIÓN GENERAL</span>
              </div>
              <div style={{ width: '2px', height: '40px', backgroundColor: T.borderActive, margin: '0 auto' }}></div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '20px' }}>
              {flujoLogicoAgentes.map((nombre, index) => (
                <React.Fragment key={nombre}>
                  <div
                    onClick={() => { setAgenteActivo(nombre); setSeccionPrincipal('CONSOLA'); }}
                    style={{ width: '100%', maxWidth: '420px', backgroundColor: T.bgPanel, border: `1px solid ${T.border}`, borderRadius: T.radiusBig, padding: '22px', cursor: 'pointer', textAlign: 'center', transition: '0.2s', boxShadow: T.shadow }}
                  >
                    <span style={{ fontSize: '11px', color: T.accent, fontWeight: '700', letterSpacing: '1px' }}>{index + 1}. {agentesInfo[nombre]?.div}</span>
                    <h4 style={{ margin: '8px 0', fontSize: '18px', fontWeight: '700' }}>{nombre}</h4>
                    <p style={{ margin: 0, fontSize: '12px', color: T.textMuted }}>{agentesInfo[nombre]?.rol}</p>
                  </div>
                  {index < flujoLogicoAgentes.length - 1 && (
                    <div style={{ width: '2px', height: '20px', backgroundColor: T.border, margin: '0 auto' }}></div>
                  )}
                </React.Fragment>
              ))}
            </div>
          </div>
        )}

        {/* 2. SETTINGS CON BOTONES DE ACCIÓN COMPLETOS */}
        {seccionPrincipal === 'SETTINGS' && (
          <div style={{ maxWidth: '1000px', margin: '0 auto', paddingBottom: '60px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: '700', marginBottom: '30px', borderBottom: `1px solid ${T.border}`, paddingBottom: '16px' }}>
              CONFIGURACIÓN <span style={{ color: T.accent }}>// EMPRESA, EQUIPO & AGENTES AI</span>
            </h2>

            {/* SECCIÓN 1: LOGO OFICIAL CON BOTÓN GUARDAR */}
            <div style={{ backgroundColor: T.bgPanel, border: `1px solid ${T.border}`, borderRadius: T.radiusBig, padding: '32px', marginBottom: '32px', boxShadow: T.shadow }}>
              <h3 style={{ margin: '0 0 16px 0', fontSize: '16px', color: T.accent }}>1. IDENTIDAD VISUAL (LOGO)</h3>
              <p style={{ fontSize: '13px', color: T.textMuted, marginBottom: '20px' }}>Sube la imagen y haz clic en "GUARDAR LOGO OFICIAL" para conservarlo en memoria.</p>
              <div style={{ display: 'flex', alignItems: 'center', gap: '20px', flexWrap: 'wrap' }}>
                <div style={{ width: '80px', height: '80px', backgroundColor: T.bgCard, border: `1px dashed ${T.accent}`, borderRadius: T.radiusSmall, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                  {(logoTemp || logoApp) ? <img src={logoTemp || logoApp} alt="Logo" style={{ maxWidth: '100%', maxHeight: '100%' }} /> : <span style={{ fontSize: '12px', color: T.textMuted }}>Sin Logo</span>}
                </div>
                <input type="file" accept="image/png, image/jpeg" onChange={handleLogoSelect} style={{ fontSize: '14px', color: T.text }} />
                <button
                  onClick={guardarLogoOficial}
                  style={{ padding: '14px 24px', backgroundColor: T.accent, color: T.btnText, border: 'none', borderRadius: T.radiusSmall, fontWeight: '700', fontSize: '13px', cursor: 'pointer', boxShadow: `0 4px 15px ${T.accent}40` }}
                >
                  ✓ GUARDAR LOGO OFICIAL
                </button>
              </div>
            </div>

            {/* SECCIÓN 2: PERFIL */}
            <div style={{ backgroundColor: T.bgPanel, border: `1px solid ${T.border}`, borderRadius: T.radiusBig, padding: '32px', marginBottom: '32px', boxShadow: T.shadow }}>
              <h3 style={{ margin: '0 0 20px 0', fontSize: '16px', color: T.accent }}>2. DATOS DE LA LICENCIA</h3>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                <div>
                  <label style={{ fontSize: '12px', color: T.textMuted, display: 'block', marginBottom: '8px' }}>Nombre Empresa / Licencia</label>
                  <input type="text" value={empresaData.nombre} onChange={(e)=>setEmpresaData({...empresaData, nombre: e.target.value})} style={{ width: '100%', padding: '14px', backgroundColor: T.bgCard, border: `1px solid ${T.border}`, borderRadius: T.radiusSmall, color: T.text, fontSize: '14px' }} />
                </div>
                <div>
                  <label style={{ fontSize: '12px', color: T.textMuted, display: 'block', marginBottom: '8px' }}>Sector / Industria</label>
                  <input type="text" value={empresaData.sector} onChange={(e)=>setEmpresaData({...empresaData, sector: e.target.value})} style={{ width: '100%', padding: '14px', backgroundColor: T.bgCard, border: `1px solid ${T.border}`, borderRadius: T.radiusSmall, color: T.text, fontSize: '14px' }} />
                </div>
              </div>
            </div>
            
            {/* SECCIÓN 3: USUARIOS CON BOTÓN ELIMINAR */}
            <div style={{ backgroundColor: T.bgPanel, border: `1px solid ${T.border}`, borderRadius: T.radiusBig, padding: '32px', marginBottom: '32px', boxShadow: T.shadow }}>
              <h3 style={{ margin: '0 0 16px 0', fontSize: '16px', color: T.accent }}>3. GESTIÓN DE EQUIPO Y ROLES (CREAR Y ELIMINAR)</h3>
              <form onSubmit={agregarUsuarioSistema} style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '12px', marginBottom: '24px' }}>
                <input type="text" placeholder="Nombre completo" value={nuevoUsuarioForm.nombre} onChange={(e)=>setNuevoUsuarioForm({...nuevoUsuarioForm, nombre: e.target.value})} style={{ padding: '12px', backgroundColor: T.bgCard, border: `1px solid ${T.border}`, borderRadius: T.radiusSmall, color: T.text, fontSize: '13px' }} />
                <input type="email" placeholder="Correo de acceso" value={nuevoUsuarioForm.email} onChange={(e)=>setNuevoUsuarioForm({...nuevoUsuarioForm, email: e.target.value})} style={{ padding: '12px', backgroundColor: T.bgCard, border: `1px solid ${T.border}`, borderRadius: T.radiusSmall, color: T.text, fontSize: '13px' }} />
                <input type="password" placeholder="Contraseña" value={nuevoUsuarioForm.pass} onChange={(e)=>setNuevoUsuarioForm({...nuevoUsuarioForm, pass: e.target.value})} style={{ padding: '12px', backgroundColor: T.bgCard, border: `1px solid ${T.border}`, borderRadius: T.radiusSmall, color: T.text, fontSize: '13px' }} />
                <button type="submit" style={{ padding: '12px', backgroundColor: T.accent, color: T.btnText, border: 'none', borderRadius: T.radiusSmall, fontWeight: '700', fontSize: '12px', cursor: 'pointer' }}>+ GUARDAR USUARIO</button>
              </form>

              <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '13px' }}>
                <thead><tr style={{ borderBottom: `1px solid ${T.border}`, color: T.textMuted }}><th style={{ padding: '12px 0' }}>Nombre & Correo</th><th style={{ padding: '12px 0' }}>Rol</th><th style={{ padding: '12px 0', textAlign: 'right' }}>Acción</th></tr></thead>
                <tbody>
                  {usuariosAutorizados.map((usr, i) => (
                    <tr key={i} style={{ borderBottom: `1px solid ${T.border}` }}>
                      <td style={{ padding: '16px 0', fontWeight: '600' }}>{usr.nombre} <br/><span style={{fontSize:'11px', color: T.textMuted, fontWeight:'400'}}>{usr.email}</span></td>
                      <td style={{ padding: '16px 0', color: T.accent, fontWeight: '700' }}>{usr.rol}</td>
                      <td style={{ padding: '16px 0', textAlign: 'right' }}>
                        <button onClick={() => eliminarUsuario(usr.email)} style={{ padding: '6px 12px', backgroundColor: 'transparent', border: '1px solid #ff4444', borderRadius: '6px', color: '#ff4444', fontSize: '11px', fontWeight: '700', cursor: 'pointer' }}>[X] ELIMINAR</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* SECCIÓN 4: CREAR Y ELIMINAR AGENTES AI */}
            <div style={{ backgroundColor: T.bgPanel, border: `1px solid ${T.border}`, borderRadius: T.radiusBig, padding: '32px', boxShadow: T.shadow }}>
              <h3 style={{ margin: '0 0 16px 0', fontSize: '16px', color: T.accent }}>4. GESTIÓN Y CREACIÓN DE AGENTES AI</h3>
              <p style={{ fontSize: '13px', color: T.textMuted, marginBottom: '20px' }}>Agrega especialistas personalizados o elimina oficinas que ya no necesites en la consola.</p>
              
              <form onSubmit={agregarNuevoAgente} style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '12px', marginBottom: '28px', backgroundColor: T.bgCard, padding: '20px', borderRadius: T.radiusSmall, border: `1px solid ${T.border}` }}>
                <div><label style={{ fontSize: '11px', color: T.textMuted }}>Nombre Agente</label><input type="text" placeholder="Ej. UX Researcher" value={nuevoAgenteForm.nombre} onChange={(e)=>setNuevoAgenteForm({...nuevoAgenteForm, nombre: e.target.value})} style={{ width: '100%', padding: '10px', backgroundColor: T.bgPanel, border: `1px solid ${T.border}`, color: T.text, fontSize: '13px', marginTop: '4px' }} /></div>
                <div><label style={{ fontSize: '11px', color: T.textMuted }}>División</label><input type="text" placeholder="Ej. PRODUCTO" value={nuevoAgenteForm.div} onChange={(e)=>setNuevoAgenteForm({...nuevoAgenteForm, div: e.target.value})} style={{ width: '100%', padding: '10px', backgroundColor: T.bgPanel, border: `1px solid ${T.border}`, color: T.text, fontSize: '13px', marginTop: '4px' }} /></div>
                <div><label style={{ fontSize: '11px', color: T.textMuted }}>Especialidad / Rol</label><input type="text" placeholder="Ej. Experiencia de Usuario" value={nuevoAgenteForm.rol} onChange={(e)=>setNuevoAgenteForm({...nuevoAgenteForm, rol: e.target.value})} style={{ width: '100%', padding: '10px', backgroundColor: T.bgPanel, border: `1px solid ${T.border}`, color: T.text, fontSize: '13px', marginTop: '4px' }} /></div>
                <div style={{ alignSelf: 'end' }}><button type="submit" style={{ width: '100%', padding: '12px', backgroundColor: T.accent, color: T.btnText, border: 'none', borderRadius: T.radiusSmall, fontWeight: '700', fontSize: '12px', cursor: 'pointer' }}>+ CREAR AGENTE AI</button></div>
              </form>

              <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '13px' }}>
                <thead><tr style={{ borderBottom: `1px solid ${T.border}`, color: T.textMuted }}><th style={{ padding: '12px 0' }}>Agente</th><th style={{ padding: '12px 0' }}>División</th><th style={{ padding: '12px 0', textAlign: 'right' }}>Acción</th></tr></thead>
                <tbody>
                  {flujoLogicoAgentes.map((nombre, i) => (
                    <tr key={i} style={{ borderBottom: `1px solid ${T.border}` }}>
                      <td style={{ padding: '14px 0', fontWeight: '700' }}>{nombre} <br/><span style={{fontSize:'11px', color: T.textMuted, fontWeight:'400'}}>{agentesInfo[nombre]?.rol}</span></td>
                      <td style={{ padding: '14px 0', color: T.accent }}>{agentesInfo[nombre]?.div}</td>
                      <td style={{ padding: '14px 0', textAlign: 'right' }}>
                        <button onClick={() => eliminarAgente(nombre)} style={{ padding: '6px 12px', backgroundColor: 'transparent', border: '1px solid #ff4444', borderRadius: '6px', color: '#ff4444', fontSize: '11px', fontWeight: '700', cursor: 'pointer' }}>[X] ELIMINAR AGENTE</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* 3. AGENDA CON CALENDARIO NATIVO (TYPE="DATE" y "TIME") */}
        {seccionPrincipal === 'AGENDA' && (
           <div style={{ maxWidth: '1000px', margin: '0 auto', paddingBottom: '60px' }}>
            <h2 style={{ fontSize: '24px', fontWeight: '700', marginBottom: '30px', borderBottom: `1px solid ${T.border}`, paddingBottom: '16px' }}>
              AGENDA Y CALENDARIO <span style={{ color: T.accent }}>// PROGRAMACIÓN DE AGENTES</span>
            </h2>
            
            <form onSubmit={agregarTareaAgenda} style={{ backgroundColor: T.bgPanel, border: `1px solid ${T.border}`, borderRadius: T.radiusBig, padding: '24px', marginBottom: '32px', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: '16px', alignItems: 'end', boxShadow: T.shadow }}>
              <div>
                <label style={{ fontSize: '11px', color: T.textMuted, display: 'block', marginBottom: '6px' }}>CALENDARIO (DÍA)</label>
                <input type="date" value={newTarea.dia} onChange={(e)=>setNewTarea({...newTarea, dia: e.target.value})} style={{ width: '100%', padding: '12px', backgroundColor: T.bgCard, border: `1px solid ${T.border}`, borderRadius: T.radiusSmall, color: T.text, fontSize: '13px' }} />
              </div>
              <div>
                <label style={{ fontSize: '11px', color: T.textMuted, display: 'block', marginBottom: '6px' }}>HORA</label>
                <input type="time" value={newTarea.hora} onChange={(e)=>setNewTarea({...newTarea, hora: e.target.value})} style={{ width: '100%', padding: '12px', backgroundColor: T.bgCard, border: `1px solid ${T.border}`, borderRadius: T.radiusSmall, color: T.text, fontSize: '13px' }} />
              </div>
              <div>
                <label style={{ fontSize: '11px', color: T.textMuted, display: 'block', marginBottom: '6px' }}>AGENTE</label>
                <select value={newTarea.agente} onChange={(e)=>setNewTarea({...newTarea, agente: e.target.value})} style={{ width: '100%', padding: '12px', backgroundColor: T.bgCard, border: `1px solid ${T.border}`, borderRadius: T.radiusSmall, color: T.text, fontSize: '13px' }}>
                  {flujoLogicoAgentes.map(ag => <option key={ag} value={ag}>{ag}</option>)}
                </select>
              </div>
              <div>
                <label style={{ fontSize: '11px', color: T.textMuted, display: 'block', marginBottom: '6px' }}>TAREA / ORDEN</label>
                <input type="text" placeholder="Escribe la directiva programada..." value={newTarea.tarea} onChange={(e)=>setNewTarea({...newTarea, tarea: e.target.value})} style={{ width: '100%', padding: '12px', backgroundColor: T.bgCard, border: `1px solid ${T.border}`, borderRadius: T.radiusSmall, color: T.text, fontSize: '13px' }} />
              </div>
              <button type="submit" style={{ padding: '12px', backgroundColor: T.accent, color: T.btnText, border: 'none', borderRadius: T.radiusSmall, fontWeight: '700', fontSize: '13px', cursor: 'pointer' }}>+ AGENDAR TAREA</button>
            </form>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '24px' }}>
              {agendaList.map((item, idx) => (
                <div key={idx} style={{ backgroundColor: T.bgPanel, border: `1px solid ${T.border}`, borderRadius: T.radiusBig, padding: '24px', borderLeft: `6px solid ${T.accent}`, boxShadow: T.shadow }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px' }}>
                    <span style={{ fontSize: '12px', fontWeight: '800', color: T.accent }}>{item.dia}</span>
                    <span style={{ fontSize: '12px', color: T.textMuted }}>{item.hora}</span>
                  </div>
                  <h4 style={{ margin: '0 0 8px 0', fontSize: '16px', fontWeight: '700' }}>{item.agente}</h4>
                  <p style={{ margin: 0, fontSize: '13px', color: T.textMuted, lineHeight: '1.5' }}>{item.tarea}</p>
                </div>
              ))}
            </div>
           </div>
        )}

        {/* 4. CONSOLA DE MANDO */}
        {seccionPrincipal === 'CONSOLA' && (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 340px', gap: '32px', height: 'calc(100vh - 80px)', minHeight: 0 }}>
            
            <div style={{ backgroundColor: T.bgPanel, border: `1px solid ${T.border}`, borderRadius: T.radiusBig, display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0, overflow: 'hidden', boxShadow: T.shadow }}>
              <div style={{ padding: '24px', borderBottom: `1px solid ${T.border}`, backgroundColor: T.bgCard, flexShrink: 0 }}>
                <span style={{ fontSize: '11px', color: T.accent, fontWeight: '700', letterSpacing: '1px' }}>{agentesInfo[agenteActivo]?.div} // OFICINA ACTIVA</span>
                <h2 style={{ margin: '6px 0 0 0', fontSize: '22px', fontWeight: '700' }}>{agenteActivo}</h2>
              </div>

              <div style={{ flex: 1, padding: '24px', overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: '16px', minHeight: 0 }}>
                {(historialChats[agenteActivo] || []).map((msj, idx) => (
                  <div key={idx} style={{ alignSelf: msj.emisor === 'CEO' ? 'flex-end' : 'flex-start', maxWidth: '85%', padding: '16px 20px', backgroundColor: msj.emisor === 'CEO' ? T.bgChatCEO : T.bgChatAI, border: `1px solid ${msj.emisor === 'CEO' ? T.accent : T.border}`, borderRadius: T.radiusSmall }}>
                    <span style={{ fontSize: '10px', color: msj.emisor === 'CEO' ? T.accent : T.textMuted, fontWeight: '700', display: 'block', marginBottom: '8px' }}>
                      {msj.emisor === 'CEO' ? 'TÚ (CEO VIVIANA CIFUENTES)' : `AI // ${agenteActivo.toUpperCase()}`}
                    </span>
                    <p style={{ margin: 0, fontSize: '14px', lineHeight: '1.6', color: T.text, whiteSpace: 'pre-wrap' }}>{msj.texto}</p>
                  </div>
                ))}
                <div ref={mensajesEndRef} />
              </div>

              <form onSubmit={enviarMensaje} style={{ padding: '20px', borderTop: `1px solid ${T.border}`, display: 'flex', gap: '12px', backgroundColor: T.bgCard, flexShrink: 0 }}>
                <input type="text" placeholder={`Escribir directiva para ${agenteActivo}...`} value={inputChat} onChange={(e)=>setInputChat(e.target.value)} style={{ flex: 1, padding: '14px 20px', backgroundColor: T.bgPanel, border: `1px solid ${T.border}`, borderRadius: '30px', color: T.text, fontSize: '14px', outline: 'none' }} />
                <button type="submit" style={{ padding: '14px 28px', backgroundColor: T.accent, color: T.btnText, border: 'none', borderRadius: '30px', fontWeight: '700', fontSize: '13px', cursor: 'pointer', boxShadow: `0 4px 15px ${T.accent}40` }}>ENVIAR</button>
              </form>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '24px', overflowY: 'auto', minHeight: 0 }}>
              <div style={{ backgroundColor: T.bgPanel, border: `1px solid ${T.border}`, borderRadius: T.radiusBig, padding: '24px', boxShadow: T.shadow }}>
                <h4 style={{ margin: '0 0 16px 0', fontSize: '15px', color: T.accent }}>PERFIL OPERATIVO</h4>
                <p style={{ margin: '0 0 20px 0', fontSize: '13px', color: T.textMuted, lineHeight: '1.6' }}>{agentesInfo[agenteActivo]?.desc}</p>
                <div style={{ padding: '16px', backgroundColor: T.bgCard, borderLeft: `4px solid ${T.accent}`, borderRadius: T.radiusSmall }}>
                  <span style={{ fontSize: '11px', color: T.textMuted, display: 'block', marginBottom: '6px' }}>PROYECTO ACTIVO</span>
                  <span style={{ fontSize: '14px', fontWeight: '600' }}>{agentesInfo[agenteActivo]?.tareaActual}</span>
                </div>
              </div>

              <div style={{ backgroundColor: T.bgPanel, border: `1px solid ${T.border}`, borderRadius: T.radiusBig, padding: '24px', boxShadow: T.shadow }}>
                <h4 style={{ margin: '0 0 12px 0', fontSize: '15px', color: T.accent }}>CHECKPOINT DE MANDO</h4>
                <p style={{ fontSize: '13px', color: T.textMuted, marginBottom: '20px', lineHeight: '1.6' }}>Revisa la calidad del trabajo antes de pasarlo al siguiente nivel en la tubería.</p>
                <button onClick={() => autorizarYTransferir(agenteActivo)} style={{ width: '100%', padding: '16px', backgroundColor: T.accent, color: T.btnText, border: 'none', borderRadius: T.radiusSmall, fontWeight: '700', fontSize: '13px', cursor: 'pointer', boxShadow: `0 4px 15px ${T.accent}40` }}>
                  ✓ APROBAR Y PASAR A {(agentesInfo[agenteActivo]?.nextAgent || flujoLogicoAgentes[0]).toUpperCase()}
                </button>
              </div>
            </div>
          </div>
        )}

      </main>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
